import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '../Carousel';
import { prismicImage } from 'src/common/utils/prismic-image';

const imageSizeOptions = ['contain', 'cover'];
const sizeOptions = ['extra-small', 'small', 'medium', 'large'];

const ProductGridCarousel = ({
  backgroundColor,
  images,
  imageSize,
  size,
  id
}) => (
  <div
    className="product-grid__carousel"
    style={{
      backgroundColor: backgroundColor,
      height: size === 'large' ? '100%' : 0
    }}>
    <div className="product-grid__carousel-inner">
      <Carousel group={`card-carousel-${id}`}>
        {images.map((image, index) => (
          <div
            className="product-grid__carousel-item"
            key={index}
            style={{
              backgroundImage: `url(${prismicImage(image.image, {
                width: imageSize === 'cover' ? 920 : undefined
              })})`,
              backgroundSize: imageSize
            }}
            draggable="true"
          />
        ))}
      </Carousel>
    </div>
  </div>
);

ProductGridCarousel.propTypes = {
  backgroundColor: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape({ image: PropTypes.any })),
  imageSize: PropTypes.oneOf(imageSizeOptions).isRequired,
  size: PropTypes.oneOf(sizeOptions).isRequired
};

export default ProductGridCarousel;
